import { render, staticRenderFns } from "./ConveniosCotasShow.vue?vue&type=template&id=0edf6227&scoped=true&"
import script from "./ConveniosCotasShow.vue?vue&type=script&lang=js&"
export * from "./ConveniosCotasShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf6227",
  null
  
)

export default component.exports